// extracted by mini-css-extract-plugin
export default {"item":"CustomCheckBox_item__kxOcy","item_wrap":"CustomCheckBox_item_wrap__Hdc2D","contents_text":"CustomCheckBox_contents_text__mC8zZ"};